export const EMPTY_ROLES_PLACEHOLDER = "--";
export const ROLE_TAG_COLOR = "blue";

export const TABLE_EMPTY_ERROR_MESSAGE = "Error";
export const TABLE_NO_ITEMS_MESSAGE = "No map views found";

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = ["10", "25", "50", "100"];
export const TABLE_SCROLL_X = 900;

export const MAP_NAME_COLUMN_WIDTH = "240px";
export const COMPANY_COLUMN_WIDTH = "220px";
export const TABLE_ELLIPSIS_CLASS = "generalStyles__ellipsis__200px";

export const MAP_EDITOR_ROUTE_PREFIX = "/edge-management/map-view/editor";
